import { apiRequest } from '@/lib/api-client';

export interface AssistantMessage {
  id: string;
  role: 'user' | 'assistant' | 'tool';
  content: string;
  toolName: string | null;
  data: Record<string, unknown> | null;
  pendingAction: { tool: string; summary: string } | null;
  actionStatus: 'awaiting_confirmation' | 'confirmed' | 'rejected' | null;
  createdAt: string;
}

export interface AssistantSession {
  id: string;
  title: string;
  updatedAt: string;
}

const base = (orgId: string, projectId: string) =>
  `/api/v1/organizations/${orgId}/projects/${projectId}/assistant`;

export const assistantApi = {
  listSessions: (orgId: string, projectId: string) =>
    apiRequest<AssistantSession[]>(`${base(orgId, projectId)}/sessions`),
  createSession: (orgId: string, projectId: string) =>
    apiRequest<{ sessionId: string }>(`${base(orgId, projectId)}/sessions`, { method: 'POST' }),
  listMessages: (orgId: string, projectId: string, sessionId: string) =>
    apiRequest<AssistantMessage[]>(`${base(orgId, projectId)}/sessions/${sessionId}/messages`),
  sendMessage: (orgId: string, projectId: string, sessionId: string, content: string) =>
    apiRequest<AssistantMessage[]>(`${base(orgId, projectId)}/sessions/${sessionId}/messages`, {
      method: 'POST',
      body: { content },
    }),
  resolveAction: (
    orgId: string,
    projectId: string,
    sessionId: string,
    messageId: string,
    decision: 'confirm' | 'reject',
  ) =>
    apiRequest<AssistantMessage[]>(
      `${base(orgId, projectId)}/sessions/${sessionId}/actions/${messageId}`,
      { method: 'POST', body: { decision } },
    ),
};
